<template>
  <bv-btn
    class="h-fit p-0"
    rounded="circle"
  >
    <bv-avatar
      bg-color="var(--color-white)"
      :image="getUserData?.img"
      :name="getUserData?.username"
      :size="40"
    />
  </bv-btn>
</template>

<script>
  import { mapState } from 'pinia';

  import { userDetailsStore } from '@/stores/auth/user-details.store';

  export default {
    name: 'PresenceStatus',
    computed: {
      ...mapState(userDetailsStore, ['getUserData']),
    },
  };
</script>
